export type EliteAffix = 'warlord' | 'bulwark' | 'splitter' | 'hoarder';

export const ELITE_AFFIXES: readonly EliteAffix[] = [
  'warlord',
  'bulwark',
  'splitter',
  'hoarder',
];

export const ELITE_AFFIX_COLORS: Record<EliteAffix, string> = {
  warlord: '#ff6b3d',
  bulwark: '#5fc8ff',
  splitter: '#a8ff5c',
  hoarder: '#ffd24d',
};

export function rollEliteAffix(rng: () => number): EliteAffix {
  const idx = Math.min(ELITE_AFFIXES.length - 1, Math.max(0, Math.floor(rng() * ELITE_AFFIXES.length)));
  return ELITE_AFFIXES[idx];
}

export function eliteDamageMultiplier(affix: EliteAffix | null | undefined, distToPlayer: number): number {
  if (affix === 'bulwark' && distToPlayer > 7.0) {
    return 0.55;
  }
  return 1;
}

export function warlordSpeedMultiplier(distToWarlord: number): number {
  return distToWarlord <= 6.0 ? 1.3 : 1;
}
